export default __webpack_public_path__ + "static/media/insert_background.af4b3c4a.png";